// removed by extract-text-webpack-plugin
module.exports = {"answer_correct_indicator":"AnswerCorrectIndicator--answer_correct_indicator--32HzM","answer_correct_indicator_wrapper":"AnswerCorrectIndicator--answer_correct_indicator_wrapper--2ATek","answer_correct_indicator_icon":"AnswerCorrectIndicator--answer_correct_indicator_icon--27k8z","answer_correct_indicator_checkmark":"AnswerCorrectIndicator--answer_correct_indicator_checkmark--KgmQa","answer_correct_indicator_text":"AnswerCorrectIndicator--answer_correct_indicator_text--2sAvp"};


//////////////////
// WEBPACK FOOTER
// /src/~/@healthwise/enhanced-shared-decision-point/components/AnswerCorrectIndicator/AnswerCorrectIndicator.css
// module id = 1012
// module chunks = 0